import React from 'react'
import NavigateNextOutlined from '@material-ui/icons/NavigateNextOutlined'

export default function NavigateNextOutlinedIcon() {

    return (
        <NavigateNextOutlined />
    )
}